module.exports = __webpack_public_path__ + "static/img/14000275.c52cb6d8.png";